var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8913 0.391304C3.8913 0.175193 3.71611 0 3.5 0C3.28389 0 3.1087 0.175193 3.1087 0.391304V2.6087H0.891304C0.675193 2.6087 0.5 2.78389 0.5 3C0.5 3.21611 0.675193 3.3913 0.891304 3.3913H3.1087V5.6087C3.1087 5.82481 3.28389 6 3.5 6C3.71611 6 3.8913 5.82481 3.8913 5.6087V3.3913H6.1087C6.32481 3.3913 6.5 3.21611 6.5 3C6.5 2.78389 6.32481 2.6087 6.1087 2.6087H3.8913V0.391304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.894ce0192c6c762ad5eb063429ad6bc3.svg";
export { ForwardRef as ReactComponent };